<template>
  <div style="padding: 10px">
    <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-plus"
      @click="openEditFunctionSwitchDialog(true)">新增开关</el-button>

    <el-table :data="functionSwitchList" border size="small" style="width: 1120px">
      <el-table-column prop="channelName" label="渠道" align="center" width="150">
      </el-table-column>
      <el-table-column prop="key" label="Key" align="center" width="130">
      </el-table-column>
      <el-table-column prop="param" label="自定义参数" align="center" width="250">
      </el-table-column>
      <!--
      <el-table-column prop="minLevel" label="得通过第几关" align="center" width="100">
      </el-table-column>
      -->
      <el-table-column prop="minVersion" label="最低版本" align="center" width="80">
      </el-table-column>
      <el-table-column prop="maxVersion" label="最高版本" align="center" width="80">
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="200"></el-table-column>
      <el-table-column label="状态" align="center" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" class="switch-status-tag switch-status-tag-off">关闭</span>
          <span v-else-if="scope.row.status == 1" class="switch-status-tag switch-status-tag-on">开启</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button type="danger" round size="mini" @click="deleteFunctionSwitch(scope.row.id, scope.row)">删除</el-button>
          <el-button type="primary" round size="mini"
            @click="openEditFunctionSwitchDialog(false, scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <EditFunctionSwitchDialog v-if="shouldEditFunctionSwitchDialogVisible" @close="onEditFunctionSwitchDialogClosed()"
      :value="valueForEditFunctionSwitchDialog"></EditFunctionSwitchDialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import EditFunctionSwitchDialog from "./EditFunctionSwitchDialog";

export default {
  data() {
    return {
      availableChannels: [], // 所有可用的渠道
      shouldEditFunctionSwitchDialogVisible: false, // 编辑对话框是否应该显示出来
      valueForEditFunctionSwitchDialog: null, // 要传递给编辑对话框的数据
      functionSwitchList: [], // 列表里展示的数据
    };
  },

  async created() {
    // 拉取渠道集合
    await this.loadAvailableChannels();

    // 拉取集合
    this.loadFunctionSwitchList();
  },

  components: {
    EditFunctionSwitchDialog,
  },

  methods: {
    /**
     * 拉取渠道集合
     */
    async loadAvailableChannels() {
      this.availableChannels = await bizutil.loadAvailableChannels();
    },

    /**
     * 查询集合
     */
    async loadFunctionSwitchList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/functionSwitch/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.switches || [];

      // 排序（按id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.functionSwitchList = listInResponse;

      // 补上渠道名称
      for (let fs of this.functionSwitchList) {
        for (let c of this.availableChannels) {
          if (c.id == fs.channelId) {
            fs.channelName = c.name;
            break;
          }
        }
      }
    },

    /**
     * 删除
     * @param {*} id
     * @param {*} entry
     */
    async deleteFunctionSwitch(id, entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除Key为“${entry.key}”、备注为“${entry.remark}”的功能开关？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/functionSwitch/delete`,
            {
              id: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.functionSwitchList.length; i++) {
          if (this.functionSwitchList[i].id == id) {
            this.functionSwitchList.splice(i, 1);
          }
        }
      } catch (e) { }
    },

    /**
     * 打开编辑对话框
     */
    async openEditFunctionSwitchDialog(isCreate, oldData) {
      this.shouldEditFunctionSwitchDialogVisible = true;
      this.valueForEditFunctionSwitchDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * 编辑对话框关闭了
     */
    async onEditFunctionSwitchDialogClosed() {
      this.shouldEditFunctionSwitchDialogVisible = false;

      // 重新拉取集合
      return this.loadFunctionSwitchList();
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>